import React from "react";
import "./LoadingView.css"; // Import CSS for styling

const LoadingView = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p className="loading-text">Loading, please wait...</p>
    </div>
  );
};

export default LoadingView;
